import * as bootstrap from 'bootstrap';

export class Toast {
  static success(title, message, time = 5000) {
    $('#toast-nav .toast-header').removeClass('toast-error');
    $('#toast-nav .toast-header').addClass('toast-success');
    Toast.display(title, message, time, 'polite', 'status');
  }

  static error(title, message, time = 5000) {
    $('#toast-nav .toast-header').removeClass('toast-success');
    $('#toast-nav .toast-header').addClass('toast-error');
    Toast.display(title, message, time, 'assertive', 'alert');
  }

  static display(title, message, time = 5000, politeness = 'polite', alertType = 'alert') {
    const element = document.querySelector('#toast-nav .toast');
    if (!element) return;

    const toast = Toast.instance(element);
    const render = () => {
      $('#toast-nav-title').html(title);
      $('#toast-nav-message').html(message);
      element.setAttribute('aria-live', politeness);
      element.setAttribute('role', alertType);
      toast.show();
      clearTimeout(Toast.hideTimer);
      Toast.hideTimer = setTimeout(() => toast.hide(), time);
    };

    if (Toast.hiding) {
      element.addEventListener('hidden.bs.toast', render, { once: true });
    } else {
      render();
    }
  }

  static instance(element) {
    const existing = bootstrap.Toast.getInstance(element);
    if (existing) return existing;

    element.addEventListener('hide.bs.toast', () => { Toast.hiding = true; });
    element.addEventListener('hidden.bs.toast', () => { Toast.hiding = false; });
    return new bootstrap.Toast(element, { autohide: false });
  }
}
